// extracted by mini-css-extract-plugin
module.exports = {"root":"MainContent_root__3Nop9","inner":"MainContent_inner__U93Fm"};